import { Box } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import LeftScrollIcon from "../../../Custom-imeges/Workflows-Icons/leftScrollIcon";
import RightScrollIcon from "../../../Custom-imeges/Workflows-Icons/RightScrollIcon";

interface SelectLibraryCategoryProps {
  categories: string[];
  activeCategory: number;
  setActiveCategory: (category: number) => void;
  categoriesBgs: string[];
}

export const SelectLibraryCategory = ({
  categories,
  activeCategory,
  setActiveCategory,
  categoriesBgs,
}: SelectLibraryCategoryProps) => {
  const categoriesContainerRef = useRef<HTMLDialogElement>();
  const [isScrollable, setIsScrollable] = useState(false);
  const [atStart, setAtStart] = useState(true);
  const [atEnd, setAtEnd] = useState(false);

  useEffect(() => {
    const checkScroll = () => {
      if (categoriesContainerRef.current) {
        const { scrollWidth, clientWidth, scrollLeft } =
          categoriesContainerRef.current;
        setIsScrollable(scrollWidth > clientWidth);
        setAtStart(scrollLeft === 0);
        setAtEnd(scrollLeft + clientWidth >= scrollWidth - 1);
      }
    };
    checkScroll();
    if (categoriesContainerRef.current) {
      categoriesContainerRef.current.addEventListener("scroll", checkScroll);
    }

    window.addEventListener("resize", checkScroll);
    return () => {
      window.removeEventListener("resize", checkScroll);
      if (categoriesContainerRef.current) {
        categoriesContainerRef.current.removeEventListener(
          "scroll",
          checkScroll
        );
      }
    };
  }, [categories]);

  const handleScrollLeft = () => {
    categoriesContainerRef.current?.scrollBy({
      left: -200,
      behavior: "smooth",
    });
  };

  const handleScrollRight = () => {
    categoriesContainerRef.current?.scrollBy({
      left: 200,
      behavior: "smooth",
    });
  };

  return (
    <Box
      className={`select-library-category ${!isScrollable && "not-scrollable"}`}
      sx={{ ml: atStart ? 1 : 0 }}
    >
      {!isScrollable ||
        (atStart && (
          <Box
            className={`scroll-left-box ${
              !isScrollable || atStart ? "disabled" : ""
            }`}
            onClick={handleScrollLeft}
          >
            <LeftScrollIcon className="custom-icon" />
          </Box>
        ))}

      <Box className="library-categories" ref={categoriesContainerRef}>
        {categories.map((category, i) => (
          <Box
            key={category}
            className={`library-app-category ${
              categories.indexOf(category) === activeCategory ? "active" : ""
            }`}
            onClick={() => setActiveCategory(categories.indexOf(category))}
            style={{
              backgroundImage: `url(${categoriesBgs[i]})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <Box className="category-overlay" />
            <Box className="category-name">{category}</Box>
          </Box>
        ))}
      </Box>

      {!isScrollable ||
        (atEnd && (
          <Box
            className={`scroll-right-box ${
              !isScrollable || atEnd ? "disabled" : ""
            }`}
            onClick={handleScrollRight}
          >
            <RightScrollIcon className="custom-icon" />
          </Box>
        ))}
    </Box>
  );
};
